var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-link",on:{"click":function($event){return _vm.$emit('clicked', $event)}}},[_c('ArrowBackIcon'),_vm._v(_vm._s(_vm.linkText))],1)}
var staticRenderFns = []

export { render, staticRenderFns }